import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import FormNuevaDerivacion from "./formNuevaDerivacion";

const NuevaDerivacionFormModal = ({
  toggle,
  isOpen,
  id,
  handleCreateDerivacion,
  vacantes,
  cobertura,
  fechaAbierta,
  setReloadCandidatos,
  idsCandidatosDerivados,
  servicio,
  candidatosDesdeMultiSelect,
  // setCandidatosDesdeMultiSelect,
  uploadOrPatchFilesCV,
}) => {
  return (
    <div>
      <Modal isOpen={isOpen} centered style={{ fontFamily: "Nunito" }}>
        <ModalHeader toggle={toggle} style={{ borderBottom: "none", background: " #f8f8f8" }}>
          Nueva derivación
        </ModalHeader>
        <ModalBody style={{ background: " #f8f8f8" }}>
          <FormNuevaDerivacion
            toggle={toggle}
            id={id}
            handleCreateDerivacion={handleCreateDerivacion}
            vacantes={vacantes}
            cobertura={cobertura}
            fechaAbierta={fechaAbierta}
            setReloadCandidatos={setReloadCandidatos}
            idsCandidatosDerivados={idsCandidatosDerivados}
            servicio={servicio}
            candidatosDesdeMultiSelect={candidatosDesdeMultiSelect}
            // setCandidatosDesdeMultiSelect={setCandidatosDesdeMultiSelect}
            uploadOrPatchFilesCV={uploadOrPatchFilesCV}
          />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default NuevaDerivacionFormModal;
